import React from 'react';
import cl from './UI/UploadModal/UploadModal.module.css'

const TupoList = ({isRepeat, head, list, listR}) => {

    return (
        <div className={cl.listWrap}>
            <p>{head}</p>
            <ul>
                {isRepeat &&
                    Array.from({ length: 5 }).map((_, index) => (
                        <li key={index}>{listR}</li>
                    ))
                }
                {!isRepeat &&
                    list.map((value, index) => (
                        <li key={index}>{value}</li>
                    ))
                }
            </ul>
        </div>
    );
};

export default TupoList;